import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, adminOnly = false, allowUnverified = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-slate-500" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Force email verification before any protected content (except the verify page itself).
  if (!allowUnverified && user.email_verified === false && location.pathname !== "/verify-email") {
    return <Navigate to="/verify-email" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
